import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Home, Briefcase, ClipboardList, Wallet, Bell, User, LogOut,
  ChevronRight, ShieldCheck, HelpCircle, Settings, Crown
} from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import '../../../../assets/css/components/serviceprovider/dashboard/workernavbar/WorkerNavbar.css';
import logo from '../../../../assets/images/logoo.jpg';
// import { useContext } from 'react';
import AppContext from '../../../../context/AppContext';
const SIDEBAR_ITEMS = [
  { label: 'Home',          path: '/worker-dashboard',     icon: <Home size={20}/> },
  { label: 'My Jobs',      path: '/bid-jobs',             icon: <Briefcase size={20}/> },
  // { label: ' Bookings',      path: '/worker-booking',       icon: <ClipboardList size={20}/> },
  { label: 'Earnings',      path: '/worker-earnings',      icon: <Wallet size={20}/> },
  { label: 'Notifications', path: '/worker-notifications', icon: <Bell size={20}/> },
  { label: 'Profile',       path: '/worker-profile',       icon: <User size={20}/> },
  { label: 'FAQs',          path: '/worker-faq',           icon: <HelpCircle size={20}/> },
  { label: 'KYC',           path: '/worker-kyc',           icon: <ShieldCheck size={20}/> },
  { label: 'Subscription',          path: '/subscription-history',           icon: <Crown size={20}/> },
  { label: 'Help & Support',path: '/worker-support',       icon: <HelpCircle size={20}/> },
  { label: 'Settings',      path: '/worker-settings',      icon: <Settings size={20}/> },
];

const WorkerNavbar = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const {authToken, setAuthToken, kycStatus, setKycStatus ,baseUrl} = useContext(AppContext);
  const [loggedInWorker, setLoggedInWorker] = useState(null);
  const ProtectedWorkerRoute = ({ children }) => {
  const { kycStatus } = useContext(AppContext);

  if (kycStatus !== "approved") {
    return <navigate to="/worker-kyc" replace />;
  }

  return children;
};



useEffect(() => {
  const authToken = localStorage.getItem('authToken');

  if (!authToken) return;

  axios.get(`${baseUrl}/worker/viewkyc`, {
    headers: { Authorization: `Bearer ${authToken}` }
  })
  .then(res => {
    const kyc = res.data.kyc;
    setKycStatus(kyc ? kyc.status : 'not_submitted');
  })
  .catch(() => {
    setKycStatus('not_submitted');
  });

}, [baseUrl]);


const protectedRoutes = [
  // '/worker-dashboard',
  '/bid-jobs',
  '/worker-earnings',
  '/worker-notifications',
  // '/worker-profile',
  '/subscription-history',
  '/worker-support',
  '/worker-settings'
];

const handleNav = (path) => {

  // Allow access to KYC page and FAQ even if KYC is not approved
  if (
    kycStatus !== "approved" &&
    protectedRoutes.includes(path)
  ) {
    Swal.fire({
      icon: "warning",
      title: "KYC Required",
      text: "Your KYC has not been approved yet. Please complete and get your KYC approved first.",
    });

    navigate('/worker-kyc');
    return;
  }

  navigate(path);
};

  const isActive = (path) =>
    path === '/worker-dashboard'
      ? location.pathname === '/worker-dashboard'
      : location.pathname.startsWith(path);




  useEffect(() => {
    console.log("-----------------------------------------");
    setAuthToken(localStorage.getItem("authToken"));
    console.log(authToken);
    console.log("-----------------------------------------");
    // const handleScroll = () => setScrolled(window.scrollY > 50);
    // window.addEventListener("scroll", handleScroll);

    const isUserLoggedIn = localStorage.getItem("loggedInWorker");
    setLoggedInWorker(isUserLoggedIn);

    // return () => window.removeEventListener("scroll", handleScroll);
  }, [loggedInWorker]);


// useEffect(() => {
//   console.log("Worker Token:", authToken);
// }, [authToken]);


  return (
    <>
      {/* ── DESKTOP SIDEBAR ── */}
      <aside className="ws-sidebar">
        <div className="ws-logo" onClick={() => navigate('/worker-dashboard')}>
        <img src={logo} alt="Logo" className="ws-logo-img"/>
          
        </div>

        <nav className="ws-nav">
          {SIDEBAR_ITEMS.map(item => (
            <button key={item.path}
              className={"ws-nav-item " + (isActive(item.path) ? 'ws-nav-item--active' : '')}
              onClick={() => handleNav(item.path)}>
              <span className="ws-nav-icon">{item.icon}</span>
              <span className="ws-nav-label">{item.label}</span>
              {isActive(item.path) && <ChevronRight size={15} className="ws-nav-chevron"/>}
            </button>
          ))}
        </nav>

        <div className="ws-sidebar-footer">
          <button className="ws-logout-btn" onClick={() => navigate('/')}>
            <LogOut size={18}/><span>Logout</span>
          </button>
        </div>
      </aside>

      {/* ── MOBILE BOTTOM NAV ── */}
      <nav className="ws-mob-bottom">
        <button className={"ws-mob-item " + (isActive('/worker-dashboard') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/worker-dashboard')}>
          <Home size={22}/><span>Home</span>
        </button>
        
        <button className={"ws-mob-item " + (isActive('/subscription-history') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/subscription-history')}>
          <Crown size={22}/><span> Subscription</span>
        </button>
        <button className={"ws-mob-item " + (isActive('/bid-jobs') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/bid-jobs')}>
          <Briefcase size={22}/><span>My Jobs</span>
        </button>
        <button className={"ws-mob-item " + (isActive('/worker-earnings') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/worker-earnings')}>
          <Wallet size={22}/><span>Earnings</span>
        </button>
        <button className={"ws-mob-item " + (isActive('/worker-profile') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/worker-profile')}>
          <User size={22}/><span>Profile</span>
        </button>
      </nav>
    </>
  );
};

export default WorkerNavbar;